import { DlpSignUpController } from "./dlp-sign-up.controller";

export class DlpSignUpComponent {
  controller: any = DlpSignUpController;
  templateUrl: string = "/html/components/dlp_sign_up";
}

angular.module("BookingApp").component("dlpSignUp", new DlpSignUpComponent());
